import {
  Button,
  Col,
  Divider, 
  Flex,
  Menu,
  Row, 
  Typography,
} from "antd";
import { Footer } from "antd/es/layout/layout";
import "./footerComponent.scss";
import { Image } from "antd";
import logo from "assets/images/logo.png";  
import { 
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
} from "@ant-design/icons";

const { Text } = Typography;

function FooterComponent() {
  return (
    <Footer
      style={{
        display: "flex",
        alignItems: "center",
        paddingTop: "100px", // Add top padding
        paddingBottom: "50px",
        paddingLeft: 0,
        paddingRight: 0, // Add bottom padding
        height: "auto",
      }}
      className="background-color-light mt-100"
    >
      <div className="container">
        <Row gutter={[32, 32]} justify="space-between">
          <Col xs={24} sm={12} md={8}>
            <Flex gap="small" justify="start" align="start" vertical>
              <div className="demo-logo">
                <Image width={200} src={logo} preview={false} />
              </div>
              <Button
                type="link"
                href="mailto:info@efficienttourism.com"
                className="dark-gray mt-2"
              >
                info@efficienttourism.com
              </Button>
              <Button type="link" href="tel:+12018953801" className="dark-gray">
                +1 (201) 895-3801
              </Button>
            </Flex>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Row gutter={[32, 32]} justify="center">
              <Col xs={24} sm={12} md={8}>
                <Menu
                  theme="light"
                  mode="vertical"
                  style={{ background: "transparent" }}
                >
                  <Menu.Item key="about">
                    <a href="/about">About Us</a>
                  </Menu.Item>
                  <Menu.Item key="team">
                    <a href="/team">Our Team</a>
                  </Menu.Item>
                  <Menu.Item key="careers">
                    <a href="/careers">Careers</a>
                  </Menu.Item>
                </Menu>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Menu
                  theme="light"
                  mode="vertical"
                  style={{ background: "transparent" }}
                >
                  <Menu.Item key="consulting">
                    <a href="/services/consulting">Consulting</a>
                  </Menu.Item>
                  <Menu.Item key="development">
                    <a href="/services/development">Development</a>
                  </Menu.Item>
                  <Menu.Item key="support">
                    <a href="/services/support">Support</a>
                  </Menu.Item>
                </Menu>
              </Col>
              <Col xs={24} sm={12} md={8}>
                <Menu
                  theme="light"
                  mode="vertical"
                  style={{ background: "transparent" }}
                >
                  <Menu.Item key="blog">
                    <a href="/blog">Blog</a>
                  </Menu.Item>
                  <Menu.Item key="faq">
                    <a href="/faq">FAQs</a>
                  </Menu.Item>
                  <Menu.Item key="contact">
                    <a href="/contact">Contact</a>
                  </Menu.Item>
                </Menu>
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider className="my-5" />

        <Row gutter={[32, 32]} justify="center">
          <Col xs={24} sm={12} md={12}>
            <Text>© 2024 Efficient Tourism.</Text>
          </Col>
          <Col xs={24} sm={12} md={12}>
            <Flex wrap gap="small" justify="end">
              <Button
                type="link"
                shape="circle"
                size="large"
                icon={<InstagramFilled />}
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              />
              <Button
                type="link"
                shape="circle"
                size="large"
                icon={<FacebookFilled />}
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              />
              <Button
                type="link"
                shape="circle"
                size="large"
                icon={<LinkedinFilled />}
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
              />
            </Flex>
          </Col>
        </Row>
      </div>
    </Footer>
  );
}

export default FooterComponent;
